<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    btnName: {
        type: String
    },
    routeName: {
        type: String
    }
})
</script>

<template>
    <Link :href="route(props.routeName)" class="rounded-full px-8 py-1.5 overflow-hidden relative group cursor-pointer border border-primaryColor font-bold bg-primaryColor">
    <span class="absolute w-64 h-0 transition-all duration-300 origin-center rotate-45 -translate-x-20 bg-white top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
    <span class="relative text-[14px] md:text-primary text-white text-nowrap transition duration-300 group-hover:text-primaryColor ease">
        {{ props.btnName}}</span>
    </Link>
</template>
